<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-clipboard-text-outline">{{
              $t("dashboardCardSuperAdminPhotoGiftSuperCategory")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeGiftSuperCategory.giftSuperCategory"
                :search="search"
                sort-by="order"
                must-sort
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100, 200],
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
                :items-per-page="50"
              >
                <template v-slot:item.active="{ item }">
                  <v-icon
                    @click="toggleGiftSuperCategoryBooleanActive(item)"
                    :color="item.active ? 'success' : 'error'"
                    >{{
                      item.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.whiteText="{ item }">
                  <v-icon
                    @click="toggleGiftSuperCategoryBooleanWhiteText(item)"
                    :color="item.whiteText ? 'success' : 'error'"
                    >{{
                      item.whiteText
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.image="{ item }">
                  <v-flex row>
                    <v-img
                      :src="
                        item.image.length > 0 ? item.image : usersNewGiftImage
                      "
                      :style="
                        item.image.length > 0
                          ? 'max-width: 100px'
                          : 'max-width: 100px'
                      "
                    ></v-img>
                    <v-icon
                      v-if="item.imageURL.length > 0"
                      class="ml-2"
                      @click="deleteImageItem(item)"
                      >mdi-delete</v-icon
                    >
                  </v-flex>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
            >
              <span v-if="beforeDeleteResultEmpty">{{
                $t("deleteDialogQuestion")
              }}</span>
              <span v-else
                >{{ $t("deleteDialogQuestionWarning2") }}
                {{ $t("deleteDialogQuestion") }}</span
              >
            </dialog-basic-yes-no>

            <!-- DELETE SIMPLE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogSimpleDelete"
              @clickYes="deleteSimpleItemImage"
              @clickNo="dialogSimpleDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("askSimpleImageDelete") }}</dialog-basic-yes-no
            >
          </v-flex>

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">{{
                $t("userNewOrderPleaseWaitTitle")
              }}</v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModulePhotoGift' })"
          ></simple-navigation-button>

          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.order"
                          type="number"
                          :label="
                            $t('settingsPhotoGiftSuperCategoryOrderTitle')
                          "
                          :rules="[validateRequired(), validateIsNumber()]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.title"
                          :label="
                            $t('settingsPhotoGiftSuperCategoryTitleTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.subtitle"
                          :label="
                            $t('settingsPhotoGiftSuperCategorySubTitleTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-file-input
                          :clearable="true"
                          accept="image/jpeg, image/png"
                          prepend-icon="mdi-camera"
                          v-model="editedItem.image"
                          class="mt-0 pa-0"
                          :label="
                            $t('settingsPhotoGiftSuperCategoryImageTitle')
                          "
                        ></v-file-input>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.whiteText"
                          :label="
                            $t('settingsPhotoGiftSuperCategoryWhiteTextTitle')
                          "
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.active"
                          :label="
                            $t('settingsPhotoGiftSuperCategoryActiveTitle')
                          "
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="my-1"
                    text
                    @click="
                      close();
                      refresh();
                    "
                    >{{ $t("addEditFormCancelButton") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";

export default {
  name: "settingsPhotoGiftSuperCategory",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      usersNewGiftImage: require("@/assets/usersNewGift.jpg"),
      search: "",
      beforeDeleteResultEmpty: true,
      dialog: false,
      dialogSimpleDelete: false,
      dialogDelete: false,
      dialogDeleteId: "",
      dialogWait: false,
      headers: [
        {
          text: this.$t("settingsPhotoGiftSuperCategoryOrderTitle"),
          align: "center",
          value: "order",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftSuperCategoryTitleTitle"),
          align: "center",
          value: "title",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftSuperCategorySubTitleTitle"),
          align: "center",
          value: "subtitle",
          sortable: true,
        },
        {
          align: "center",
          value: "image",
        },
        {
          text: this.$t("settingsPhotoGiftSuperCategoryWhiteTextTitle"),
          align: "center",
          value: "whiteText",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftSuperCategoryActiveTitle"),
          align: "center",
          value: "active",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      editedIndex: -1,
      editedItem: {
        order: "",
        title: "",
        subtitle: "",
        image: [],
        imageURL: "",
        whiteText: false,
        active: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
      defaultItem: {
        order: "",
        title: "",
        subtitle: "",
        image: [],
        imageURL: "",
        whiteText: false,
        active: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    async toggleGiftSuperCategoryBooleanActive(item) {
      try {
        await this.$store.dispatch(
          "toggleGiftSuperCategoryBooleanActive",
          item
        );
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async toggleGiftSuperCategoryBooleanWhiteText(item) {
      try {
        await this.$store.dispatch(
          "toggleGiftSuperCategoryBooleanWhiteText",
          item
        );
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deleteImageItem(item) {
      this.dialogSimpleDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteSimpleItemImage() {
      try {
        this.dialogWait = true;
        await firebase
          .functions()
          .httpsCallable("deleteImageFromStorage")([
            this.dialogDeleteId.imageURL,
          ])
          .then(async (res) => {
            await this.$store.dispatch(
              "removeImageLinkFromGiftSuperCategory",
              this.dialogDeleteId
            );
            this.dialogWait = false;

            if (res.data[0] == "OK") {
              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("msgSuccessImageDelete"),
              });
            } else
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("msgErrorImageDelete"),
              });
          })
          .catch((error) => {
            this.dialogWait = false;
            console.log(error);
          });
        this.dialogWait = false;

        this.dialogSimpleDelete = false;
      } catch (error) {
        this.dialogWait = false;
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async deleteItemSet(item) {
      this.dialogWait = true;
      this.beforeDeleteResultEmpty = await this.$store.dispatch(
        "beforeDeleteRemoveGiftSuperCategory",
        {
          client: this.$store.state.storeClient.client.basicSettings.name,
          superCategory: item.title,
        }
      );
      this.dialogWait = false;
      this.dialogDelete = true;
      this.dialogDeleteId = item.id;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch(
          "removeGiftSuperCategory",
          this.dialogDeleteId
        );
        this.dialogDelete = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    editItem(item) {
      this.editedIndex =
        this.$store.state.storeGiftSuperCategory.giftSuperCategory.indexOf(
          item
        );
      item.image2 = item.image; // duplikat, da ne izgine slika v prikazu baze
      item.image = [];
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    refresh() {
      this.dialog = false;
      this.$store.dispatch("getGiftSuperCategory", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
      });
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.dialogWait = true;
        if (this.editedIndex > -1) {
          try {
            if (Array.isArray(this.editedItem.image))
              delete this.editedItem.image;
            await this.$store.dispatch(
              "editGiftSuperCategory",
              this.editedItem
            );
            await this.$store.dispatch("getGiftSuperCategory", {
              client: this.$store.state.storeClient.client.basicSettings.name,
              mode: "edit",
            });

            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            if (Array.isArray(this.editedItem.image))
              delete this.editedItem.image;
            await this.$store.dispatch("addGiftSuperCategory", this.editedItem);

            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
  created() {
    this.$store.dispatch("getGiftSuperCategory", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      mode: "edit",
    });
  },
};
</script>